/**
 * PORTED (REWRITTEN) — RO-3-00d / #44471.
 * Origin: `excellent/app/projects/[projectSlug]/[sectionSlug]/_crm/templates.tsx`.
 *
 * Vault read `listTemplates()` moved behind already-mounted `crm.templates.list`.
 * New-template form reuses the co-ported `NewTemplateClient`.
 */

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  EmptyState,
  PageHeader,
} from "@excellent/ui";
import { useApi } from "@excellent/ui/api";
import { crm } from "@excellent/ui/api/contracts/crm";
import { NewTemplateClient, TemplatesClient } from "./client";

export function TemplatesView() {
  const { data, error, isLoading } = useApi(crm.templates.list, {});
  const templates = data?.templates ?? [];

  return (
    <div className="flex flex-col gap-4">
      <PageHeader
        title="Email templates"
        description="Reusable email bodies to drop into any sequence or one-off send."
      />
      {error ? (
        <p className="type-body text-destructive">{error.message ?? String(error)}</p>
      ) : null}
      <Card>
        <CardHeader>
          <CardTitle>New template</CardTitle>
        </CardHeader>
        <CardContent>
          <TemplatesClient />
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle>Library</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading && !data ? (
            <p className="type-body text-muted-foreground">Loading…</p>
          ) : templates.length === 0 ? (
            <EmptyState variant="inline" title="No templates yet" />
          ) : (
            <ul className="flex flex-col">
              {templates.map((t) => (
                <li
                  key={t.id}
                  className="border-b border-border/40 py-3 type-body first:pt-0 last:border-b-0 last:pb-0"
                >
                  <div className="flex items-baseline gap-2">
                    <span className="text-foreground">{t.name}</span>
                    <span className="text-muted-foreground">/{t.slug}</span>
                  </div>
                  <div className="mt-1 text-muted-foreground">{t.subject}</div>
                  <pre className="mt-2 max-h-40 overflow-auto rounded-md bg-muted/40 p-2 type-body">
                    {t.body_text}
                  </pre>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export function NewTemplateView({ basePath }: { basePath: string }) {
  return (
    <div className="mx-auto flex max-w-xl flex-col gap-4">
      <PageHeader
        title="New email template"
        description="Write a reusable email you can send or add to a sequence."
      />
      <NewTemplateClient basePath={basePath} />
    </div>
  );
}
